function qinticOut(t) {
  return --t * t * t * t * t + 1;
}
module.exports = qinticOut;